export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Маркетинг',
        path: '/cases/marketing',
    },
];

export const listTitle = [
    {
        title: 'Контекстная реклама для медицинских центров АВЕНЮ',
        subtitle:
            'В&nbsp;рекламе платной медицины есть много тонкостей и&nbsp;нюансов. Рассказываем, как\n' +
            '                            получать лиды в&nbsp;конкурентной нише, какую выбрали стратегию для сети АВЕНЮ\n' +
            '                            и&nbsp;сколько клиентов удалось привлечь в&nbsp;результате ведения проекта.',
        description: [
            {
                name: 'Отрасль',
                details: 'Здравоохранение',
            },
            {
                name: 'Услуги',
                details: 'Контекстная реклама',
            },
        ],
        company: 'Сеть медицинских центров АВЕНЮ',
        companyLink: 'https://avenumed.ru/',
        companyLinkName: 'avenumed.ru',
        text: 'Сеть многопрофильных медицинских центров АВЕНЮ, которая включает 14&nbsp;поликлиник в&nbsp;Ростовской области и&nbsp;Тюмени, а&nbsp;также собственную лабораторию.',
    },
];
export const descriptionBlock = {
    title: 'Описание проекта',
    leftText:
        'Маркетинговая команда агентства &laquo;Вебпрактик&raquo; работает с&nbsp;клиентом с&nbsp;2016&nbsp;года. Спектр задач из&nbsp;года в&nbsp;год меняется: усиление брендового присутствия, привлечение первичных лидов, проведение коротких акций в&nbsp;несезон. По&nbsp;мере роста сети появлялись задачи по&nbsp;привлечению заявок в&nbsp;конкретные филиалы. На&nbsp;этот раз стояла задача по&nbsp;привлечению посетителей в&nbsp;новый медицинский центр, открывшийся в&nbsp;городе Ростове-на-Дону.',
    rightText: 'Сеть поликлиник в&nbsp;Ростовской области и&nbsp;Тюмени',
    img: '/images/svg/avenu/avenu-logo.svg',
    alt: 'Логотип компании Авеню',
};

export const className = 'avenu';

export const listTarget = [
    {
        name: 'Цель',
        description:
            'Привлечение качественных лидов в&nbsp;новый филиал клиники стоимостью не&nbsp;выше 800&nbsp;руб.',
    },
];

export const listDescription = [
    {
        title: 'Описание проекта',
        text: [
            {
                paragraph:
                    'Маркетинговая команда агентства &laquo;Вебпрактик&raquo; работает с&nbsp;клиентом с&nbsp;2016&nbsp;года. Спектр задач из&nbsp;года в&nbsp;год меняется: усиление брендового присутствия, привлечение первичных лидов, проведение коротких акций в&nbsp;несезон. По&nbsp;мере роста сети появлялись задачи по&nbsp;привлечению заявок в&nbsp;конкретные филиалы. На&nbsp;этот раз стояла задача по&nbsp;привлечению посетителей в&nbsp;новый медицинский центр, открывшийся в&nbsp;городе Ростове-на-Дону.',
            },
            {
                paragraph:
                    'В&nbsp;условиях пандемии произошел бурный рост маркетплейсов, которые активно заняли поисковую выдачу. Из-за этого прежние подходы к&nbsp;SEO-продвижению товаров и&nbsp;услуг перестали приносить желаемые результаты.',
            },
            {
                paragraph:
                    'Для привлечения целевого трафика на&nbsp;сайт в&nbsp;качестве гипотезы мы&nbsp;предложили попробовать контент-инструменты, чтобы охватить информационные запросы. Статьи&nbsp;&mdash; это не&nbsp;уникальное решение, но&nbsp;важен формат и&nbsp;стиль текстов. Для интернет-магазина с&nbsp;большим ассортиментом разных групп товаров остановились на&nbsp;формате рейтингов/топов.',
            },
        ],
    },
];

export const description = 'Сеть поликлиник в&nbsp;Ростовской области и&nbsp;Тюмени';

export const listTask = [
    {
        number: '1',
        text: 'Разработать рекламную стратегию.',
    },
    {
        number: '2',
        text: 'Увеличить количество заявок с сайта.',
    },
    {
        number: '3',
        text: 'Снизить цену за лид.',
    },
];

export const difficulties = {
    leftText:
        'С&nbsp;одной стороны, медицинские услуги&nbsp;&mdash; это высококонкурентная ниша, где нужно переманивать клиентов. ' +
        'С&nbsp;другой, очень широкая целевая аудитория. В&nbsp;нашем проекте помимо общих сложностей были еще внутренние ограничения. ' +
        'Это большое количество направлений и&nbsp;услуг, отсутствие сквозной аналитики и&nbsp;коллтрекинга. Поэтому сайт стал основным каналом ' +
        'взаимодействия клиентов с&nbsp;клиникой. Также было важно сохранить распределение аудитории между филиалами клиники и&nbsp;не&nbsp;перетягивать&nbsp;их.',
    rightText: 'Сайт стал основным каналом взаимодействия клиентов с&nbsp;клиникой.',
    title: 'Сложности проекта',
};

export const test = {
    rightText: 'Собрали семантическое ядро из&nbsp;ключевых запросов',
    num: '6 000+',
};

export const firstStart = {
    leftText:
        'Первый запуск показал неудовлетворительные результаты по&nbsp;качеству трафика и&nbsp;конверсионности. ' +
        'Сразу отключили кампании с&nbsp;околотематическими ключевыми запросами и&nbsp;с&nbsp;общими ключами по&nbsp;симптоматике заболеваний. ' +
        'В&nbsp;РСЯ показатели были также неудовлетворительными, но&nbsp;от&nbsp;данного канала не&nbsp;стали полностью отказываться, ' +
        'так как он&nbsp;давал недорогой трафик и&nbsp;служил базой для ретаргетинга. ',
    rightText: 'Инструменты для запуска РК',
    img: '/images/svg/avenu/logo1.svg',
    alt: 'Рекламная сеть',
};

export const processBlock = {
    leftText:
        'Старт любого проекта начинается с&nbsp;анализа прошлых рекламных кампаний, успешных гипотез,\n' +
        '                    сильных и&nbsp;слабых сторон продукта/услуги, ЦА&nbsp;и&nbsp;конкурентов. На&nbsp;основе этих\n' +
        '                    выводов, и&nbsp;не&nbsp;забывая о&nbsp;целях, разработали стратегию продвижения и&nbsp;выбрали\n' +
        '                    рекламные каналы.',
    title: 'Процесс',
};

export const firstStart2 = {
    leftText: `<p>
            Оставили кампании по&nbsp;специализациям врачей с&nbsp;ключевыми фразами по&nbsp;прямому интересу посетить врача. 
            Также скорректировали бюджет в&nbsp;пользу поисковых рекламных кампаний, которые дают&nbsp;90% от&nbsp;общего количества первичных лидов. 
        </p>
        <p>
            Оставили объявления, стимулирующие переход на&nbsp;сайт и&nbsp;целевое действие. 
            Так как в&nbsp;нашем проекте сайт медцентра&nbsp;&mdash; основная точка взаимодействия будущих пациентов с&nbsp;клиникой, 
            то&nbsp;мы&nbsp;мотивировали пользователей оставлять заявки именно через этот канал. 
            Для этого в&nbsp;текстах транслировали материальную выгоду, которую дополняли промокодами с&nbsp;ограниченным сроком действия.
        </p>`,
    rightText: '%&nbsp;поисковых рекламных компаний от&nbsp;общего количества первичных лидов',
    num: '90%',
};

export const screenShotCase = {
    images: ['/images/pic/avenu/screen1.jpg', '/images/pic/avenu/screen2.jpg'],
    title: 'Примеры успешных поисковых кампаний',
};

export const paragraph = {
    leftText:
        'После работ по&nbsp;оптимизации рекламных кампаний практически сразу увидели положительную динамику ' +
        'и&nbsp;по&nbsp;количеству лидов, и&nbsp;по&nbsp;их&nbsp;стоимости. Но&nbsp;пока они не&nbsp;соответствовали плановой стоимости. ' +
        'Средняя цена за&nbsp;лид находилась в&nbsp;пределах 1600&nbsp;руб.',
};

export const statistics = {
    blocks: [
        {
            title: 'Отказы',
            icon: '/images/svg/common/close.svg',
            before: 'на&nbsp;',
            number: '25%&nbsp;',
            after: 'ниже',
        },
        {
            title: 'CTR',
            icon: '/images/svg/common/ctr.svg',
            before: 'на&nbsp;',
            number: '5,87%&nbsp;',
            after: '',
        },
        {
            title: 'Среднее кол-во страниц',
            icon: '/images/svg/common/eye.svg',
            before: 'на&nbsp;',
            number: '0,46&nbsp;',
            after: 'выше',
        },
    ],
};

export const statistics1 = {
    blocks: [
        {
            title: 'Средняя цена за лид, руб.',
            before: '',
            icon: '/images/svg/common/money.svg',
            number: '1 600',
            after: '',
        },
    ],
};

export const changeStrategy = {
    leftText:
        'Команда приняла решение о&nbsp;кардинальной смене рекламной стратегии, и&nbsp;отключили все работавшие ранее рекламные кампании. ' +
        'Выдвинули гипотезу, что клиенты ищут не&nbsp;только специализацию врача, но&nbsp;и&nbsp;конкретного врача клиники. ' +
        'Поэтому собрали семантику по&nbsp;ФИО врачей всех филиалов АВЕНЮ в&nbsp;Ростове-на-Дону и&nbsp;соседнем городе Батайске. ' +
        'Получилось более 200 ключевых запросов. В&nbsp;текст объявлений добавили информацию про скидки и&nbsp;акции для стимулирования записи через сайт.',
    rightText:
        'В&nbsp;текст объявлений добавили информацию про скидки и&nbsp;акции для стимулирования записи через сайт.',
};

export const screenShotCase2 = {
    images: ['/images/pic/avenu/screen3.jpg'],
    title: 'Пример измененной рекламной кампании',
};

export const paragraph2 = {
    leftText: `
        <p>
            Сразу пошла положительная динамика. Лидов стало больше и&nbsp;они стали значительно дешевле. 
            Провели анализ и&nbsp;отключили все объявления, где цена лида была в&nbsp;2&nbsp;раза выше плановой. Также отсекли не&nbsp;конверсионную аудиторию: почти для всех групп понизили мужскую аудиторию.
        </p>
        <p>
            Всего через одну неделю после этих корректировок стратегия обучилась, и&nbsp;мы&nbsp;стали получать лиды не&nbsp;выше 800&nbsp;рублей.
        </p>
    `,
};

export const results = {
    title: 'Результаты',
    leftText:
        'Спустя 3&nbsp;месяца работы в&nbsp;рамках новой успешной гипотезой удалось стабильно получать плановое количество лидов, ' +
        'которое постоянно росло. При этом стоимость конверсии стала даже ниже 800&nbsp;рублей. И&nbsp;еще через месяц мы&nbsp;вышли ' +
        'на&nbsp;минимальную стоимость лида в&nbsp;рамках этого проекта&nbsp;&mdash; 318&nbsp;руб.',
};

export const statistics2 = {
    blocks: [
        {
            title: 'Рост количества лидов',
            icon: '/images/svg/common/growth.svg',
            before: 'х',
            number: '4',
            after: '',
        },
        {
            title: 'Снизили стоимость лида',
            icon: '/images/svg/common/decrease.svg',
            before: 'x',
            number: '10',
            after: '',
        },
        {
            title: 'Средняя стоимость лида',
            icon: '/images/svg/common/money.svg',
            before: '',
            number: '318 ',
            after: 'руб.',
        },
    ],
};

export const diagrammBlock = {
    title: 'Динамика стоимости лида',
    image: '/images/svg/avenu/diagram.svg',
};

export const listTeam = [
    {
        title: 'Команда',
        members: [
            {
                name: 'Виктория Вишненко',
                position: 'Менеджер проекта',
            },
            {
                name: '2 PPC-специалиста',
            },
        ],
    },
];

export const nextProjectAvenu = {
    nextProjectTitle: 'Медведь. Интернет-магазин',
    nextProjectImg: '/images/pic/avenu/bear.jpg',
    nextProjectLink: '/cases/marketing/medved',
    nextProjectLinkTitle: 'Медведь. Интернет-магазин',
    nextProjectText:
        'В этом кейсе расскажем, какие тексты нужны интернет-магазину для роста продаж без привлечение платных рекламных',
};

export const strategyText = {
    leftText: `
        <p>Запустили только поисковые кампании на&nbsp;ручной стратегии с&nbsp;максимальными ставками. С&nbsp;помощью ретаргетинга в&nbsp;РСЯ увеличивали процент повторных записей на&nbsp;прием к&nbsp;специалистам. 
        В&nbsp;объявлениях транслировали скидку на&nbsp;повторную запись в&nbsp;течение месяца. </p>
        <p>Спустя 6&nbsp;месяцев тестирования разных гипотез вышли на&nbsp;хорошие результаты: отказы снизились на&nbsp;25%, CTR вырос на&nbsp;5,87%, 
        среднее количество просматриваемых на&nbsp;сайте страниц увеличилось на&nbsp;0,46.</p>
    `,
};

export const nextStageText = {
    leftText: `
    <p>Следующий этап&nbsp;&mdash; работа по&nbsp;снижению стоимости лида. Решили протестировать автостратегию с&nbsp;оплатой за&nbsp;конверсию. На&nbsp;проекте уже накопилось достаточно данных для обучения стратегии. 
    Указали желаемую стоимость за&nbsp;конверсию и&nbsp;запустили стратегию. </p>
    <p>В&nbsp;итоге мы&nbsp;получили в&nbsp;2&nbsp;раза меньше лидов за&nbsp;двухнедельных период, чем на&nbsp;ручной стратегии. А&nbsp;его цена снизилась всего на&nbsp;12%. Это все равно намного выше плановой.</p>
    `,
};

export const optimizationText = {
    leftText: `
        <p>В&nbsp;рамках новой гипотезы установили повышающую корректировку на&nbsp;поиске по&nbsp;теплой аудитории, которая ранее посещала сайт клиники. Следующим этапом необходимо было увеличить количество переходов на&nbsp;сайт, 
        так как это напрямую влияло на&nbsp;конверсии.</p>
        <p>Для этого мы&nbsp;вынесли ФИО врача и&nbsp;минимальную стоимость приема в&nbsp;заголовки, добавили специализацию врача в&nbsp;текст объявления, а&nbsp;также указали сроки действия акции. После всех корректировок запустили стратегию оптимизации конверсий.</p>
    `,
    rightText:
        'Наши объявления выходили на&nbsp;первых позициях, поэтому сконцентрировались на&nbsp;улучшении текстов, чтобы увеличить CTR.',
};

export const screenShotCase4 = {
    images: ['/images/pic/avenu/screen4.jpg'],
    title: 'Пример измененной рекламной кампании',
};
